import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import VueMoment from "vue-moment";
import "buefy/dist/buefy.css";
// import VueWorker from 'vue-worker'
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  lazyComponent: true
});

Vue.use(Buefy);
Vue.use(VueMoment);
// Vue.use(VueWorker)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
